import { useAppSelector } from "@/common/hooks/useRedux";
import { MergeVisitsDialog } from "./MergeVisitsDialog";
import { UnmergeConfirm } from "./UnmergeConfirm";

/**
 * EN-1196: rendered by PermissionWrapper, so it remounts with each page; renders whichever merge dialog Redux
 * says is open.
 */
export function MergeVisitsDialogHost() {
    const dialog = useAppSelector((s) => s.mergeVisitsUi.dialog);
    const unmerge = useAppSelector((s) => s.mergeVisitsUi.unmerge);
    return (
        <>
            {dialog && <MergeVisitsDialog sourceId={dialog.sourceId} initialTargetId={dialog.targetId} />}
            {unmerge && (
                <UnmergeConfirm mergeId={unmerge.mergeId} targetId={unmerge.targetId} targetTime={unmerge.targetTime} />
            )}
        </>
    );
}
